import { METHOD_POST } from 'requests';
import { ApiRequestConfigType } from 'requests/index.types';
import { INVITE_BY_SPREADSHEET } from 'constants/endpoints';

export const API_POST_inviteBySpreadsheet = (params: {
  formData: FormData;
}): ApiRequestConfigType => {
  const url = INVITE_BY_SPREADSHEET;
  return {
    __typename: 'LegacyAPI',
    method: METHOD_POST,
    url,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    body: params.formData,
  };
};
